import {
    useEffect,
} from 'react'

import StatusHandler from 'app/shared-components/StatusHandler'
import {
    CancelFeeConfirmationDialog,
} from 'app/shared-components/CancelFee'
import useCountOrdersLaneFee from '../hooks/useCountOrdersLaneFee'

type Props = {
    id: number,
    cancelFee: {
        askConfirmation: () => void,
        openConfirmDialog: boolean,
        doAction: (param: boolean) => void,
    }
    reason: string,
    setReason: (param: string) => void,
}

const LaneFeeCancellation = ({
    id,
    cancelFee,
    reason,
    setReason,
}: Props) => {
    const {
        openConfirmDialog,
        doAction,
    } = cancelFee

    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
    } = useCountOrdersLaneFee(id, {
        openConfirmDialog,
    })

    useEffect(() => {
        if (isDataReady && openConfirmDialog && data?.orderCount === 0) {
            doAction(true)
        }
    }, [
        data?.orderCount,
        openConfirmDialog,
        doAction,
        isDataReady,
    ])

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            {data?.orderCount > 0 ? (
                <CancelFeeConfirmationDialog
                    title="Lane Fee"
                    openConfirmDialog={openConfirmDialog}
                    handleClose={doAction}
                    reason={reason}
                    setReason={setReason}
                    orderCount={data?.orderCount}
                />
            ) : null}
        </StatusHandler>
    )
}

export default LaneFeeCancellation
